import React from "react";
import { Link } from "react-router-dom";
import { scrollTop } from "../../layout/scripts/scroll";

interface Props {
  label: string;
  title: string;
  button: string;
  linkTo: string;
  imgTeaser1x: string;
  imgTeaser2x: string;
  imgTeaserMobile1x: string;
  imgTeaserMobile2x: string;
}

const LandingTeaser: React.FC<Props> = ({
  label,
  title,
  button,
  linkTo,
  imgTeaser1x,
  imgTeaser2x,
  imgTeaserMobile1x,
  imgTeaserMobile2x,
}) => {
  return (
    <Link to={linkTo} className="teaser grid-3-3" onClick={() => scrollTop()}>
      <div className="teaser__label">{label}</div>
      <div className="img-wrap teaser__img-wrap">
        <picture data-crop="false" data-quality="high" data-upscale="false">
          <source
            data-width=""
            media="screen and (min-width:768px)"
            srcSet={`${imgTeaser1x} 1x, ${imgTeaser2x} 2x`}
          />
          <source
            data-width=""
            media="screen and (max-width:767px)"
            srcSet={`${imgTeaserMobile1x} 1x, ${imgTeaserMobile2x} 2x`}
          />
          <img className="img" alt="teaser img" data-title="laptop" src={imgTeaser1x} />
        </picture>
      </div>

      <div className="teaser__text-wrap">
        <h2 className="teaser__title">{title}</h2>
        <div className="btn teaser__btn btn--arrow">
          <span className="btn__text">{button}</span>
        </div>
      </div>
    </Link>
  );
};

export default LandingTeaser;
